import React, { Component } from "react";
import testAnswers from "../../components/tests/test7/test7answers";
import "./userAnswers.css";
import { NavLink } from "react-router-dom";
class UserAnswers extends Component {
    state = {
        userAnswers: null,
        testName: null
    };

    processAnswers = (answers, testName) => {
        debugger;
        let testNames = answers.name;
        console.log(testNames, answers);
        let data = {};
        switch (testNames) {
            case "Test9" : {
                data.name= "Test9";
                data.results = answers.answers;
            }
            break;
            case "Test7":
                {
                    console.log(answers.answers);
                    answers.answers.map(elem => {
                        elem.isUserAnswerCorrect =
                            elem.sworipasux == "true" ? true : false;
                        elem.degree = parseInt(elem.gradusi);
                        elem.reverse = elem.revers;
                        elem.answerTime = parseInt(elem.pasuxdro);
                        elem.answered =
                            elem.upasuxtuara == "true" ? true : false;
                    });

                    data.name = "Test7";
                    data.results = answers.answers;
                }
                break;
            case "Test6":
                {
                    answers.answers.map(elem => {
                        elem.isUserAnswerCorrect =
                            elem.sworipasux == "true" ? true : false;
                        elem.firstLetter = elem.pirveliaso;
                        elem.firstKey = elem.pirvelgilak;
                        elem.secondLetter = elem.meoreaso;
                        elem.secondKey = elem.meoregilak;
                        elem.thirdLetter = elem.mesameaso;
                        elem.thirdKey = elem.mesamegilak;
                        elem.fourthLetter = elem.meotxeaso;
                        elem.fourthKey = elem.meotxegilak;
                        elem.userAnswer = elem.momxpasux;
                        elem.answerTime = parseInt(elem.pasuxdro);
                        elem.answered =
                            elem.upasuxtuara == "true" ? true : false;
                        elem.type = elem.type;
                        elem.stimul = elem.stimul;
                        elem.reverse = elem.revers;
                        elem.answerTime = parseInt(elem.pasuxdro);
                    });

                    data.name = "Test6";
                    data.results = answers.answers;
                }
                break;
            case "Test5":
                {
                    answers.answers.map(elem => {
                        elem.isUserAnswerCorrect =
                            elem.sworipasux == "true" ? true : false;
                        elem.degree = parseInt(elem.gradusi);
                        elem.reverse = elem.revers;
                        elem.answerTime = parseInt(elem.pasuxdro);
                    });

                    data.name = "Test5";
                    data.results = answers.answers;
                }
                break;
            case "Test4":
                {
                    answers.answers.map(elem => {
                        elem.variant = elem.variant;
                        elem.margin = parseInt(elem.dashoreba);
                        elem.firstLetter = elem.pirveliaso;
                        elem.secondLetter = elem.meoreaso;
                        elem.userAnswer = elem.momxpasux;
                        elem.answerTime = parseInt(elem.pasuxdro);
                        elem.answered =
                            elem.upasuxtuara === "true" ? true : false;
                        elem.isUserAnswerCorrect =
                            elem.sworipasux == "true" ? true : false;
                        elem.aimStimul = elem.aimStimul;
                        elem.distractor = elem.distractor;
                        elem.distractorType = elem.distractorType;
                    });

                    data.name = "Test4";
                    data.results = answers.answers;
                }
                break;
            case "Test3":
                {
                    answers.answers.map(elem => {
                        elem.isUserAnswerCorrect =
                            elem.sworipasux == "true" ? true : false;
                        elem.degree = parseInt(elem.gradusi);
                        elem.reverse = elem.revers;
                        elem.answerTime = parseInt(elem.pasuxdro);
                    });

                    data.name = "Test3";
                    data.results = answers.answers;
                }
                break;
            case "Test2":
                {
                    answers.answers.map(elem => {
                        elem.isUserAnswerCorrect =
                            elem.sworipasux == "true" ? true : false;
                        elem.degree = parseInt(elem.gradusi);
                        elem.reverse = elem.revers;
                        elem.answerTime = parseInt(elem.pasuxdro);
                        elem.similarityType = elem.similarityType;
                    });

                    data.name = "Test2";
                    data.results = answers.answers;
                }
                break;
            case "Test1":
                {
                    answers.answers.map(elem => {
                        elem.isUserAnswerCorrect =
                            elem.sworipasux == "true" ? true : false;
                        elem.degree = parseInt(elem.gradusi);
                        elem.reverse = elem.revers;
                        elem.answerTime = parseInt(elem.pasuxdro);
                    });

                    data.name = "Test1";
                    data.results = answers.answers;
                }
                break;
        }
        localStorage.setItem("chartData", JSON.stringify(data));
        localStorage.setItem("new", false);
    };

    translateDates = date => {
        let translatedDay, translatedMonth;
        let day = date.substr(0, 3).toLowerCase();
        let month = date.substr(4, 3).toLowerCase();

        switch (day) {
            case "mon":
                translatedDay = "ორშაბათი";
                break;
            case "tue":
                translatedDay = "სამშაბათი";
                break;
            case "wed":
                translatedDay = "ოთხშაბათი";
                break;
            case "thu":
                translatedDay = "ხუთშაბათი";
                break;
            case "fri":
                translatedDay = "პარასკევი";
                break;
            case "sat":
                translatedDay = "შაბათი";
                break;
            case "sun":
                translatedDay = "კვირა";
                break;
        }
        switch (month) {
            case "jan":
                translatedMonth = "იანვარი";
                break;
            case "feb":
                translatedMonth = "თებერვალი";
                break;
            case "mar":
                translatedMonth = "მარტი";
                break;
            case "apr":
                translatedMonth = "აპრილი";
                break;
            case "may":
                translatedMonth = "მაისი";
                break;
            case "jun":
                translatedMonth = "ივნისი";
                break;
            case "jul":
                translatedMonth = "ივლისი";
                break;
            case "aug":
                translatedMonth = "აგვისტო";
                break;
            case "sep":
                translatedMonth = "სექტემბერი";
                break;
            case "oct":
                translatedMonth = "ოქტომბერი";
                break;
            case "nov":
                translatedMonth = "ნოემბერი";
                break;
            case "dec":
                translatedMonth = "დეკემბერი";
                break;
        }

        return `${translatedDay}, ${translatedMonth}, ${date.substr(8)}`;
    };

    componentDidMount() {
        let testAnswers = JSON.parse(localStorage.getItem("userAnswers"));
        console.log(testAnswers);
        debugger;
        let userAnswers = [];
        for (let answers in testAnswers.answers) {
            let singleTest = {};
            singleTest.testName = answers;
            singleTest.name = testAnswers.name;
            singleTest.answers = testAnswers.answers[answers];
            userAnswers.push(singleTest);
        }
        userAnswers.map(element => {
            element.testName = element.testName.substring(
                0,
                element.testName.indexOf("GMT") - 1
            );
        });
        // let testName = testAnswers.name;
        console.log(userAnswers);
        // this.setState({userAnswers,testName});
        this.setState({ userAnswers });
    }
    render() {
        // let userAnswers = this.state.userAnswers;
        // console.log(testAnswers);
        // debugger;
        let userAnswers = this.state.userAnswers;
        // console.log(userAnswers);
        let testName = this.state.testName;
        let element = null;
        if (userAnswers) {
            element = userAnswers.map((elem, i) => {
                return (
                    <li
                        className="answered-test-li"
                        key={i}
                        onClick={() => {
                            this.processAnswers(elem, testName);
                        }}
                    >
                        <h2 className="answered-test-name">
                            <NavLink to={`${process.env.PUBLIC_URL}/result`}>
                                {this.translateDates(elem.testName)}
                            </NavLink>
                        </h2>
                    </li>
                );
            });
        }
        return (
            <div className="answered-test-list">
                <ul className="answered-test-ul">{element}</ul>
            </div>
        );
    }
}

export default UserAnswers;
